<template lang="pug">
  transition(name="fade")
    .faceAssetComp( ref="area")

      .content( ref="content" v-if="hasData")
        .bg( ref="bg")
        .feature(v-for="(value, key) in features" :class = "[key]" :style="{transformOrigin: getAssetTransformOrigin(key), transform: getAssetTransform(key)}" )
          .feature_fill(
            v-if="hasColorMask(key)"
            :style="{backgroundColor: getColorMask(key) , maskImage: 'url('+require('@/assets/img/feature_assets/'+ getImage(key, value, true)) +')' }"
          )
          .feature_val(
            :style="{backgroundImage: 'url('+require('@/assets/img/feature_assets/'+ getImage(key, value)) +')' }"
          )


</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import $ from "jquery"



  export default {
    name: 'faceAssetComp',
    components: {
    },
    data() {
      return {
        hasData:false,

        asset_remaps:{

          //FACIAL HAIR:SHADOW IS MASK ONLY
          'shadow_extra_heart.png':"none.png",
          'shadow_heart.png':"none.png",
          'shadow_average.png':"none.png",
          'shadow_rect.png':"none.png",
          'shadow_extra_rect.png':"none.png",

          //FACIAL HAIR:THIN IS MASK ONLY
          'facial_hair_full_beard_thin_extra_heart.png':'none.png',
          'facial_hair_full_beard_thin_heart.png':'none.png',
          'facial_hair_full_beard_thin_average.png':'none.png',
          'facial_hair_full_beard_thin_rect.png':'none.png',
          'facial_hair_full_beard_thin_extra_rect.png':'none.png',

          'facial_hair_chin_mustache_thin_extra_heart.png':'none.png',
          'facial_hair_chin_mustache_thin_heart.png':'none.png',
          'facial_hair_chin_mustache_thin_average.png':'none.png',
          'facial_hair_chin_mustache_thin_rect.png':'none.png',
          'facial_hair_chin_mustache_thin_extra_rect.png':'none.png',

          //FACIAL HAIR: chin_mustache : NO THIN ASSETS PROVIDED
          'facial_hair_chin_mustache_thin_extra_heart_mask.png':'facial_hair_chin_mustache_thick_extra_heart_mask.png',
          'facial_hair_chin_mustache_thin_heart_mask.png':'facial_hair_chin_mustache_thick_heart_mask.png',
          'facial_hair_chin_mustache_thin_average_mask.png':'facial_hair_chin_mustache_thick_average_mask.png',
          'facial_hair_chin_mustache_thin_rect_mask.png':'facial_hair_chin_mustache_thick_rect_mask.png',
          'facial_hair_chin_mustache_thin_extra_rect_mask.png':'facial_hair_chin_mustache_thick_extra_rect_mask.png',



          //TEMP NON GENDERED ASSETS
          // 'hat_male_beanie.png':"hat_beanie.png",
          // 'hat_female_beanie.png':"hat_beanie.png",
          // 'hat_male_beanie_mask.png':"hat_beanie_mask.png",
          // 'hat_female_beanie_mask.png':"hat_beanie_mask.png",
          //
          // 'glasses_male_square.png':"glasses_square.png",
          // 'glasses_female_square.png':"glasses_square.png",
          // 'glasses_male_square_mask.png':"glasses_square_mask.png",
          // 'glasses_female_square_mask.png':"glasses_square_mask.png",

          //
          // 'facial_hair_goatee_thin_extra_heart':'none',
          // 'facial_hair_goatee_thin_heart':'none',
          // 'facial_hair_goatee_thin_average':'none',
          // 'facial_hair_goatee_thin_rect':'none',
          // 'facial_hair_goatee_thin_extra_rect':'none',

        },


        feature_colors:{
          skin_color:'',
          hat_color:'',
          hair_color:'',
          eye_color:'',
          facial_hair_color:'',
          eye_brow_color:''
        },

        masks:{
          eyes:null
        },

        feature_sizes:{
          mouth_width:1,
          face_width:1,
          chin_height:1,
          neck_width:1.1
        },

        feature_offsets:{
          eyebrow_offsetY:0,
          //cheek_offsetY:0.05
        },

        feature_rotations:{
          eye_brows_rotation:0,
          eye_rotation:0,
        },

        features:{
          hair_back:'',
          neck:'',
          ears:'',
          face_shape:'',

          //


          facial_hair_shadow:'',
          facial_hair:'',

          //
          glasses:'',
          eye_brows:'',
          eyes:'',
          eye_brows_right:'',
          eyes_right:'',

          //
          mouth:'',

          cheeks:'',
          nose:'',

          hair_front:'',
          hat:'',

        }
      }
    },
    props: {},
    computed: {
    },

    mounted() {

      ////require all images in assets
      (function () {
        var req = require.context('@/assets/img/feature_assets', true, /\.png$/);
        req.keys().forEach(function (key) {
          req(key);
          console.log('require asset:', key)
        });
      })();

      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },

    beforeDestroy() {},

    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      hasAsset(key){
        return key.indexOf('color') !==-1
      },

      getAssetTransformOrigin(k){
        let t = '50% 50%'
        let p = FaceFeatureService.transformPoints[k]
        if (p){t = (p.x *100)+'% ' + (p.y *100)+'%'}

        return t

      },

      getAssetTransform(k){
        let f = FaceFeatureService
        let fa = f.faceAssets
        let w = this.getAssetWidthScale(k)
        let h = this.getAssetHeightScale(k)

        let right = (k.indexOf("_right") > -1)

        let r = this.getAssetRotation(k) //deg
        let x = this.getAssetXOffset(k)
        let y = this.getAssetYOffset(k)

        let rw = 2480 * 0.125 //this.$refs['content'].getBoundingClientRect().width

        //accomodate asset flip for 'right' -assets
        if (right){
            w= 0-w
            let p = f.transformPoints[k]
            if (p){
              let x2 = p.x
              x += ((0.5-x2)  * rw) * 2
            }
        }

        return  'translate('+ x +'px, '+ y +'px ) scale('+ w+' , '+ h+') rotate('+r+'deg )'
      },

      getAssetYOffset(k){
        let fa = FaceFeatureService.faceAssets
        let rh = 3508 * 0.125
        let y = 0
        let fo = this.feature_offsets
        if (k === 'eye_brows' || k === 'eye_brows_right'){
          y = fo.eyebrow_offsetY * rh
          y += ((fa.female) ? -0.003 * rh : 0.001 * rh)
        }
        if (k === 'mouth'){ y = fo.mouth_offsetY * rh}
        if (k === 'nose'){ y = fo.nose_offsetY * rh}
        if (k === 'cheeks'){ y = fo.cheek_offsetY * rh}

        return y

      },

      getAssetXOffset(k){
        let fa = FaceFeatureService.faceAssets
        let rw = 2480 * 0.125
        let x = 0
        let fo = this.feature_offsets
        //if (k === 'eyes' || k === 'eyes_right'){ x =  0.2 * -rw}
        if (k === 'eye_brows' ){
          x = fo.eyebrow_offsetX * rw
          x -= ((fa.female) ? 0.01 * rw : 0.01 * rw)
        }
        if (k === 'eye_brows_right'){
          x = 0-(fo.eyebrow_offsetX * rw)
          x += ((fa.female) ? 0.01 * rw : 0.01 * rw)
        }

        if (k === 'eyes' ){ x = fo.eye_offsetX * rw}
        if (k === 'eyes_right'){ x = 0-(fo.eye_offsetX * rw)}

        return x
      },


      getAssetRotation(k){
        let r = 0
        let fr = this.feature_rotations
        if (k === 'eye_brows'){ r = fr.eye_brows_rotation}
        if (k === 'eye_brows_right'){ r = fr.eye_brows_rotation}

        if (k === 'eyes'){ r = fr.eye_rotation}
        if (k === 'eyes_right'){ r = fr.eye_rotation}

        return r
      },

      getAssetWidthScale(k){
        let fa = FaceFeatureService.faceAssets
        let w = 1
        let s = this.feature_sizes
        if (k === 'mouth'){ w = s.mouth_width}

        if (k === 'eyes' || k === 'eyes_right'){ w = fa.eye_size}
        if (k === 'eye_brows' || k === 'eye_brows_right'){ w = fa.eye_brow_scaleX}

        if (k === 'nose'){ w = (fa.female) ? 0.9 : 1.0}

        if (k === 'ears'){ w = s.face_width}
        if (k === 'glasses'){ w = s.face_width}
        if (k === 'facial_hair'){ w = s.face_width}
        if (k === 'facial_hair_shadow'){ w = s.face_width}
        if (k === 'hat'){ w = s.face_width}
        if (k === 'face_shape'){ w = s.face_width}
        if (k === 'cheeks'){ w = s.face_width}
        if (k === 'neck'){ w = s.neck_width}
        if (k === 'hair_front'){ w = s.face_width}
        if (k === 'hair_back'){ w = s.face_width}



        return w || 1
      },

      getAssetHeightScale(k){
        let fa = FaceFeatureService.faceAssets
        let h = 1
        let s = this.feature_sizes
        //if (k === 'face_shape'){ h = s.chin_height}

        if (k === 'face_shape'){ h = s.chin_height}

        if (k === 'facial_hair'){ h = 1.0 - (this.feature_offsets.mouth_offsetY * 4)}
        if (k === 'facial_hair_shadow'){ h = 1.0 - (this.feature_offsets.mouth_offsetY * 4)}

        if (k === 'eyes' || k === 'eyes_right'){ h = fa.eye_size}
        if (k === 'eye_brows' || k === 'eye_brows_right'){ h = 1.0}

        return h
      },


      getAssetWidthPerc(k){
        return (this.getAssetWidthScale(k)*100)+'%'
      },

      getAssetRemap(s){
        if (this.asset_remaps[s]){return this.asset_remaps[s]}
        return s
      },

      getImage(k,v, isMask){
        console.log('getImage', k, v)
        if (!v || v === 'none') {return 'none.png'}

        if (isMask) { return (this.masks[k]) ? this.getAssetRemap(this.masks[k]+'_mask.png') :this.getAssetRemap(v+'_mask.png')}
        return this.getAssetRemap(v+'.png')
      },

      hasColorMask(key){
        let colorMasks = FaceFeatureService.assetColorMasks
        return (!!colorMasks[key])
      },

      getColorMask(key){
        let colorMasks = FaceFeatureService.assetColorMasks
        return '#'+ (this.feature_colors[colorMasks[key]] || 'ff0000')
      },

      onFaceInfo(info){
        this.face_info = info
        this.hasData = !!this.face_info

        if(!this.hasData){return}

        let fa = FaceFeatureService.faceAssets

        let o = this.features
        let c = this.feature_colors
        let s = this.feature_sizes
        let fr = this.feature_rotations
        let fo = this.feature_offsets
        let m = this.masks

        m.eyes = fa.eyes_mask
        m.eyes_right = fa.eyes_mask
        m.facial_hair_shadow = fa.facial_hair_shadow

        o.hair_front = fa.hair_front
        o.hair_back = fa.hair_back

        o.neck = fa.neck
        o.ears = fa.ears

        o.cheeks = fa.cheeks

        o.eye_brows = fa.eye_brows
        o.eyes = fa.eyes
        o.eye_brows_right = fa.eye_brows
        o.eyes_right = fa.eyes

        fr.eye_rotation = fa.eye_rotation
        fr.eye_brows_rotation = fa.eye_brows_rotation
        fo.eyebrow_offsetY = fa.eyebrow_offsetY
        fo.eyebrow_offsetX = fa.eyebrow_offsetX

        fo.eye_offsetX = fa.eye_offsetX

        fo.mouth_offsetY = fa.mouth_offsetY
        fo.nose_offsetY = fa.nose_offsetY


        o.face_shape = fa.face_shape
        s.face_width = fa.face_width
        s.neck_width = fa.face_width * 1.05
        o.facial_hair = fa.facial_hair
        o.facial_hair_shadow = fa.facial_hair_shadow
        o.glasses = fa.glasses
        // o.hair = fa.hair

        o.neck = fa.neck

         o.hat = fa.hat
         o.mouth = fa.mouth
         s.mouth_width = fa.mouth_width
         s.chin_height = fa.chin_height
         o.nose = fa.nose

        c.hat_color = fa.hat_color
        c.facial_hair_color = fa.facial_hair_color
        c.eye_brow_color = fa.eye_brow_color
        c.hair_color = fa.hair_color
        c.skin_color = fa.skin_color //fa.skin_color
        c.lip_color = fa.lip_color //fa.skin_color
        c.eye_color = fa.eye_color


      },

    },

    watch: {
    },
  }
</script>

<style lang="sass">
  @import "src/styles/common.sass"

  .faceAssetComp
    position: relative
    display: inline-block
    width: 2480px * 0.125
    height: 3508px * 0.125
    overflow: hidden
    contain: layout

    .bg
      +full()
      background-color:  rgba(140,140,140,1.0)

    .content
      position: absolute
      display: block
      overflow: hidden
      width: 2480px * 0.125
      height: 3508px * 0.125

    .feature
      +full()

    .feature_val
      background-blend-mode: multiply
      background-size: 100% 100%
      background-repeat: no-repeat
      background-position: top left
      +full()

    .feature_fill
      +full()
      mask-size: 100% 100%
      background-color: #00dfff


</style>
